import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AgCellWrapperComponent } from '@shared/ag-components/ag-cell-wrapper/ag-cell-wrapper.component';
import { Utils } from '@shared/utils/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, NgClass],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    @if (percent > 0) {
      <div class="flex items-center justify-items-start space-x-2" [ngStyle]="{ width: '100%' }">
        @if (percent > 0) {
          <div
            class="flex h-5 items-center justify-end pr-8"
            [ngClass]="{
              'bg-aux-blue': percent <= 100,
              'bg-aux-error': percent > 100,
            }"
            [ngStyle]="{ width: percent + '%' }"
          ></div>
        }
        <span class="ml-1 tabular-nums text-aux-black" [attr.auto-qa]="autoTestAttribute">
          {{ percent }}%
        </span>
      </div>
    }
    @if (percent === 0) {
      <div
        class="flex items-center justify-items-start space-x-2"
        [attr.auto-qa]="autoTestAttribute"
      >
        {{ dash }}
      </div>
    }
    @if (percent < 0) {
      <div [attr.auto-qa]="autoTestAttribute"></div>
    }
  `,
})
export class PortfolioCompleteComponent
  extends AgCellWrapperComponent
  implements ICellRendererAngularComp
{
  bgClass!: string;
  dash = Utils.zeroHyphen;
  params!: ICellRendererParams;
  percent!: number;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.percent = params.data.complete || 0;

    this.autoTestAttribute = this.getAutoTestAttribute(params);
  }
}
